export default "/dist/files/post.d70f83df2b82b28d23c68a5888c8f81e.svg";